import { PopoverContent } from "@/components/ui/popover";
import { cx } from "@/utils/cx";
import type { ComponentProps } from "react";

interface PopoverProps extends Omit<ComponentProps<typeof PopoverContent>, "className"> {
    size: "sm" | "md" | "lg";
    className?: string;
}

export const Popover = ({ size, className, ...props }: PopoverProps) => {
    return (
        <PopoverContent
            align="start"
            {...props}
            className={cx(
                "w-(--anchor-width) overflow-x-hidden overflow-y-auto bg-popover py-1",
                size === "sm" && "max-h-56",
                size === "md" && "max-h-64",
                size === "lg" && "max-h-80",
                className,
            )}
        />
    );
};
